import { IBankConnection } from '@/types'
import { BANK_CONNECTION_STATUS, BANK_INSTITUTION_STATUS, STATUS } from '@/utils/constants'

// Connections on which an available institution is worth saying so: one in use, or one still
// being set up.
const SHOWS_AVAILABLE: string[] = [BANK_CONNECTION_STATUS.ACTIVE, STATUS.PENDING]

// The institution's status shown beside a connection. "Available" is only shown on an active or
// pending connection; on any other it is left off. A degraded or down institution is always shown,
// since that can explain why the connection is not working.
export const shownInstitutionStatus = (connection: IBankConnection) => {
  const institutionStatus = connection.institutionStatus?.trim()
  if (!institutionStatus) return undefined

  const isAvailable = institutionStatus.toLowerCase() === BANK_INSTITUTION_STATUS.AVAILABLE
  const connectionStatus = connection.status?.trim().toLowerCase() ?? ''
  return isAvailable && !SHOWS_AVAILABLE.includes(connectionStatus) ? undefined : institutionStatus
}
